<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Master Maksimal Bobot'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')"
              dataTitleTooltip="Tambah Data" />
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="itemsWithIndex" :search="search" class="custom-header">
                <template v-slot:item.no="{ item }">
                  {{ item.no }}
                </template>
                <template v-slot:item.status="{ item }">
                  <b-badge v-if="item.status === true" class="mr-1" variant="primary">Aktif</b-badge>
                  <b-badge v-else class="mr-1" variant="danger">Non-Aktif</b-badge>
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)"
                    dataTitleTooltip="Edit" />
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"
                    dataTitleTooltip="Hapus" />
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>
        <b-modal @ok="onSubmit" ok-title="Simpan" ok-variant="primary" no-enforce-focus cancel-title="Batal"
          cancel-variant="danger" id="modal" :title="`${statusModal} Maksimal Bobot`">
          <b-form>
            <b-form-group label="Aspek">
              <b-form-input id="jenis_aspek" type="text" v-model="request.aspect" required
                placeholder="Masukkan Aspek"></b-form-input>
            </b-form-group>

            <b-form-group label="Maksimal Bobot">
              <vue-number v-model="request.weight" v-bind="number" required
                placeholder="Masukkan Maksimal Bobot"></vue-number>
              <!-- <b-form-input id="bobot" type="text" v-model="request.weight" required placeholder="Masukkan Maksimal Bobot"></b-form-input> -->
            </b-form-group>

            <b-form-group label="Status :">
              <b-form-radio-group>
                <b-form-radio-group v-model="request.status" :options="statusE"
                  name="radio-inline-2"></b-form-radio-group>
              </b-form-radio-group>
            </b-form-group>

          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import axios from "axios";

export default {
  data() {
    return {
      statusE: [
        { value: 'true', text: "Aktif" },
        { value: 'false', text: "Non-Aktif" }
      ],
      statusModal: '',
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
      dataMaxWeights: [],
      request: {
        key: null,
        weight: null,
        aspect: null,
        status: null,
        status_inti: null
      },
      search: "",
      headers: [
        { text: "No", value: "no", align: "center", sortable: false },
        { text: "Aspek", value: "aspect" },
        { text: "Maksimal Bobot", value: "max_weight" },
        { text: "Status", value: "status" },
        { text: "Aksi", value: "action", align: "center", sortable: false }
      ],
    };
  },
  computed: {
    itemsWithIndex() {
      return this.dataMaxWeights.map(
        (dataMaxWeights, index) => ({
          ...dataMaxWeights,
          no: index + 1
        }))
    }
  },
  components: {
    KTCodePreview,
    ButtonComponent,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Master Maksimal Bobot" }
    ]);

    this.getData()
  },
  methods: {
    openModal(status, itemData = null) {
      this.statusModal = status

      // reset form
      this.request = {
        key: null,
        aspect: null,
        weight: null,
        status: null,
        status_inti: null
      }
      if (status == 'Edit') {
        this.request.key = itemData.key
        this.request.aspect = itemData.aspect
        this.request.weight = itemData.max_weight
        this.request.status = itemData.status
        this.request.status_inti = null
      }
    },

    async getData() {
      try {
        const result = await axios.get(`master/max-weights`)

        this.dataMaxWeights = result.data.data;
      } catch (err) {
        this.$swal(`Failed`);
      }
    },

    async onSubmit() {
      const form = this.request


      if (form.key === null) {
        // store
        this.store(form)
      } else {
        // update
        this.update(form)
      }
    },

    async store(form) {

      try {
        var formData = {
          aspect: form.aspect,
          weight: form.weight,
          status: form.status,
          status_inti: 't'
        };

        const result = await axios.post(`master/max-weight`, formData)

        this.refreshData(result, 'Store')
      } catch (err) {
        this.$swal(`Failed`);
      }
    },

    async update(form) {
      try {
        var formData = {
          aspect: form.aspect,
          weight: form.weight,
          status: form.status,
          status_inti: 't'
        };


        const result = await axios.put(`master/max-weight/${form.key}`, formData)

        this.refreshData(result, 'Update')
      } catch (err) {
        this.$swal(`Failed`);
      }
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Success ${alert} Data`);
        this.getData()
      } else if (result.data.meta.code == 409) {
        this.$swal(`${result.data.meta.message}`);
        this.getData()
      } else {
        this.$swal(`Failed`);
      }
    },

    async deleteData(key) {
      try {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this item!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            // User confirmed, so delete the item
            const result = await axios.delete(`master/max-weight/${key}`)
            this.refreshData(result, 'Delete')
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
        this.$swal(`Failed`);
      }
    },
  },
}
</script>